import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const SOCServices: React.FC = () => {
  const sections = [
    {
      title: '24/7 Security Operations Center (SOC) Services',
      content: 'Our SOC services provide round-the-clock security monitoring, threat detection, and incident response capabilities. Our expert security analysts continuously monitor your environment using advanced SIEM platforms, threat intelligence, and machine learning to identify and respond to security threats.',
      benefits: [
        '24/7/365 security monitoring and alerting',
        'Advanced threat detection and analysis',
        'Incident response and containment',
        'Threat hunting and investigation',
        'Security metrics and reporting'
      ]
    },
    {
      title: 'SOC Capabilities',
      content: 'Our SOC combines human expertise with advanced technology to provide comprehensive security operations services.',
      benefits: [
        'Multi-tier analyst support structure',
        'SIEM platform management and tuning',
        'Threat intelligence integration',
        'Playbook-driven incident response',
        'Regular security posture assessments'
      ]
    }
  ];

  const sidebarInfo = [
    {
      title: 'Service Levels',
      content: 'Multiple service tiers available from basic monitoring to full managed security services with dedicated analysts.'
    },
    {
      title: 'Technology Stack',
      content: 'Industry-leading SIEM, SOAR, and threat intelligence platforms with custom integration capabilities.'
    },
    {
      title: 'Compliance Support',
      content: 'SOC services designed to support PCI DSS, HIPAA, SOX, and other regulatory compliance requirements.'
    }
  ];

  return (
    <ServiceTemplate
      title="SOC Services"
      subtitle="Comprehensive 24/7 Security Operations Center services providing continuous monitoring, threat detection, and incident response."
      sections={sections}
      ctaTitle="Enhance Your Security Posture"
      ctaDescription="Get round-the-clock protection with our expert SOC services and advanced threat detection capabilities."
      sidebarInfo={sidebarInfo}
    />
  );
};

export default SOCServices;

